export default "__VITE_ASSET__70686c1c__"